import React, { useEffect, useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { Typography, Button } from '@material-tailwind/react';
import { seleccionarTextoInput } from '../../Helpers/utilidades-globales';
import { MagnifyingGlassCircleIcon } from '@heroicons/react/24/outline';
import Axios from 'axios';

export const TabDatosContacto = ({ values, handleChange, setFieldValue, provincias, setBuscarProvincias, toggleModalProvincia, id_obrero }) => {

    const [distritos, setDistritos] = useState([]);

    useEffect(() => {
        if (values.id_region) {
            Axios.get(`/api/tablasgenerales/distritos/${values.id_region}`)
                .then(res => setDistritos(res.data))
                .catch(err => console.error('Error al cargar distritos', err));
        } else {
            setDistritos([]);
        }
    }, [values.id_region]);

    return (
        <div className="bg-white p-5 rounded-md mb-4 relative min-h-[400px]">
            <div className="flex flex-col mt-2">
                <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-medium "
                >
                    Direcci&oacute;n
                </Typography>
                <Field
                    id="abm-direccion"
                    type="text"
                    autoComplete="off"
                    maxLength="100"
                    name="direccion"
                    onFocus={() => seleccionarTextoInput("abm-direccion")}
                    onClick={() => seleccionarTextoInput("abm-direccion")}
                    className={`input-ui-data ${values.direccion ? 'input-cvalor' : 'input-vacio'}`}
                />
                <div className="error_formulario"><ErrorMessage name="direccion" /></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div className="flex flex-col mt-2">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        Barrio
                    </Typography>
                    <Field
                        id="abm-barrio"
                        type="text"
                        autoComplete="off"
                        maxLength="100"
                        name="barrio"
                        onFocus={() => seleccionarTextoInput("abm-barrio")}
                        onClick={() => seleccionarTextoInput("abm-barrio")}
                        className={`input-ui-data ${values.barrio ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="barrio" /></div>
                </div>

                <div className="flex flex-col mt-2">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        Localidad
                    </Typography>
                    <Field
                        id="abm-localidad"
                        type="text"
                        autoComplete="off"
                        maxLength="500"
                        name="localidad"
                        onFocus={() => seleccionarTextoInput("abm-localidad")}
                        onClick={() => seleccionarTextoInput("abm-localidad")}
                        className={`input-ui-data ${values.localidad ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="localidad" /></div>
                </div>

                <div className="flex flex-col el-abm-sel-pos">
                    <div className="flex space-x-2 f-row justify-between items-center mb-1">
                        <Typography variant="small" color="blue-gray" className="font-medium">
                            Provincia
                        </Typography>
                        <Button type="button"
                            variant='text'
                            className="flex cursor-pointer p-0 m-0"
                            onClick={() => { setBuscarProvincias(true); if(toggleModalProvincia) toggleModalProvincia() }}>
                            <MagnifyingGlassCircleIcon width={16} className='mr-1' />
                            <span className='text-xs'>Buscar</span>
                        </Button>
                    </div>
                    <select
                        onChange={handleChange}
                        value={values.id_provincia}
                        name="id_provincia"
                        className="select-bg-ui w-full" id="abm-provincia"
                    >
                        <option disabled value="-1">Seleccionar</option>
                        {
                            provincias && provincias.map(item =>
                                <option key={`abmcprovincia${item.id_provincia}`}
                                    value={item.id_provincia}>{item.nombre}</option>
                            )
                        }
                    </select>
                    <div className="error_formulario"><ErrorMessage name="id_provincia" /></div>
                </div>

                <div className="flex flex-col el-abm-sel-pos">
                    <div className="flex space-x-2 f-row justify-between items-center mb-1">
                        <Typography variant="small" color="blue-gray" className="font-medium ">
                            Distrito
                        </Typography>
                    </div>
                    <select
                        disabled={false}
                        onChange={(e) => { 
                            handleChange(e); 
                            if(setFieldValue) setFieldValue('id_distrito', e.target.value); 
                        }}
                        value={values.id_distrito || ''}
                        name="id_distrito"
                        className="select-bg-ui w-full" id="abm-distrito"
                    >
                        <option value="" disabled className='text-gray-400'>Seleccione un distrito...</option>
                        {distritos.map(item => (
                            <option key={`abmcndistrito${item.id_distrito_region || item.id_distrito}`} value={item.id_distrito}>{item.nombre}</option>
                        ))}
                    </select>
                    <div className="error_formulario"><ErrorMessage name="id_distrito" /></div>
                </div>

                <div className="flex flex-col mt-2">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        C&oacute;digo Postal
                    </Typography>
                    <Field
                        id="abm-cod_postal"
                        type="text"
                        autoComplete="off"
                        maxLength="10"
                        name="cod_postal"
                        onFocus={() => seleccionarTextoInput("abm-cod_postal")}
                        onClick={() => seleccionarTextoInput("abm-cod_postal")}
                        className={`input-ui-data ${values.cod_postal ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="cod_postal" /></div>
                </div>

                <div className="flex flex-col mt-2">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        Tel&eacute;fono
                    </Typography>
                    <Field
                        id="abm-telefono"
                        type="text"
                        autoComplete="off"
                        onFocus={() => seleccionarTextoInput("abm-telefono")}
                        onClick={() => seleccionarTextoInput("abm-telefono")}
                        maxLength="500"
                        name="telefono"
                        className={`input-ui-data ${values.telefono ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="telefono" /></div>
                </div>
                
                <div className="flex flex-col mt-2">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        Celular
                    </Typography>
                    <Field
                        id="abm-alumno-celular"
                        type="text"
                        autoComplete="off"
                        onFocus={() => seleccionarTextoInput("abm-celular")}
                        onClick={() => seleccionarTextoInput("abm-celular")}
                        maxLength="500"
                        name="celular"
                        className={`input-ui-data ${values.celular ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="celular" /></div>
                </div>

                <div className="flex flex-col mt-2">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        E-mail
                    </Typography>
                    <Field
                        id="abm-email"
                        type="email"
                        autoComplete="off"
                        maxLength="100"
                        onFocus={() => seleccionarTextoInput("abm-email")}
                        onClick={() => seleccionarTextoInput("abm-email")}
                        name="email"
                        value={values.email?.toLowerCase()}
                        className={`input-ui-data ${values.email ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="email" /></div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 mb-2">
                <div className="flex flex-col">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        E-mail Tesoreria
                    </Typography>
                    <Field
                        id="abm-email-tesoreria"
                        type="email"
                        autoComplete="off"
                        maxLength="100"
                        onFocus={() => seleccionarTextoInput("abm-email-tesoreria")}
                        onClick={() => seleccionarTextoInput("abm-email-tesoreria")}
                        name="email_tesoreria"
                        value={values.email_tesoreria?.toLowerCase()}
                        className={`input-ui-data ${values.email_tesoreria ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="email_tesoreria" /></div>
                </div>

                <div className="flex flex-col">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        E-mail Secretaria
                    </Typography>
                    <Field
                        id="abm-email-secretaria"
                        type="email"
                        autoComplete="off"
                        maxLength="100"
                        onFocus={() => seleccionarTextoInput("abm-email-secretaria")}
                        onClick={() => seleccionarTextoInput("abm-email-secretaria")}
                        name="email_secretaria"
                        value={values.email_secretaria?.toLowerCase()}
                        className={`input-ui-data ${values.email_secretaria ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="email_secretaria" /></div>
                </div>

                <div className="flex flex-col">
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium "
                    >
                        Email
                    </Typography>
                    <Field
                        id="abm-email-pastor"
                        type="email"
                        autoComplete="off"
                        maxLength="100"
                        onFocus={() => seleccionarTextoInput("abm-email-pastor")}
                        onClick={() => seleccionarTextoInput("abm-email-pastor")}
                        name="email_pastor"
                        value={values.email_pastor?.toLowerCase()}
                        className={`input-ui-data ${values.email_pastor ? 'input-cvalor' : 'input-vacio'} w-full`}
                    />
                    <div className="error_formulario"><ErrorMessage name="email_pastor" /></div>
                </div>
            </div>
        </div>
    );
};